'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _retcodeUtil = require('@ali/retcode-util');

var _retcodeUtil2 = _interopRequireDefault(_retcodeUtil);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var request = function request(ctx) {
  var params = ctx.req.params;
  // 处理 retcode
  if (params.enableRetCode) {
    ctx.retCode = _retcodeUtil2.default.retCode(params.retApiName || (0, _utils.deleteSearch)(params.url));
  }

  return ctx;
};

var response = {
  fulfilled: function fulfilled(ctx) {
    ctx.retCode && ctx.retCode.success();
    return ctx;
  },
  rejected: function rejected(err) {
    var ctx = err.ctx;
    if (ctx && ctx.retCode) {
      ctx.retCode.failed((0, _utils.extractErrorInfo)(err, ctx.req.params));
    }
    throw err;
  }
};

exports.default = { request: request, response: response };